export interface FilterableColumnDefinition {
  field: string;
  hasColumnDelimiter: boolean;
}
